// BEGIN SORTED WORKFLOW AREA string-imports FOR vue/add-view sdk/add-component
import { import_export_card_strings } from "./components/import-export-card/ImportExportCard.strings.ts";
import { company_profile_display_strings } from "./displays/company-profile-display/CompanyProfileDisplay.strings.ts";
import { part_view_strings } from "./displays/part-detail-card/PartView.strings.ts";
import { parts_table_strings } from "./displays/parts-table/PartsTable.strings.ts";
import { company_profile_form_strings } from "./forms/company-profile-form/CompanyProfileForm.strings.ts";
import { part_file_uploader_strings } from "./forms/part-file-uploader/PartFileUploader.strings.ts";
import { part_form_strings } from "./forms/part-form/PartForm.strings.ts";
import { part_interest_form_strings } from "./forms/part-interest-form/PartInterestForm.strings.ts";
// END WORKFLOW AREA

import { sdkStrings } from "@saflib/sdk/strings";

export const powerUpSdkStrings = {
  // BEGIN SORTED WORKFLOW AREA string-object FOR vue/add-view sdk/add-component
  company_profile_display_strings,
  company_profile_form_strings,
  import_export_card_strings,
  part_view_strings,
  part_file_uploader_strings,
  part_form_strings,
  part_interest_form_strings,
  parts_table_strings,
  // END WORKFLOW AREA
  ...sdkStrings,
};

export { fileCategoryLables } from "./forms/part-interest-form/PartInterestForm.strings.ts";
